import { Preferences } from "../../profile/objects/preferences";
import { IATA_AIRLINE_MODULE } from "../constant/iataAirlineConstant";
import { Column } from "../objects/column";

export const setIataAirlinePreference = (new_preferences: Preferences[], state_columns: Column[]): { order_by: string, order: 'asc' | 'desc', columns: Column[], preferences: Preferences[] } => {
    const field_name: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = '';
    let order: 'asc' | 'desc' = 'asc';
    new_preferences.map((preference: Preferences) => {
        if (preference.module === IATA_AIRLINE_MODULE) {
            if (!field_name.includes(preference.field_name)) {
                switch (preference.field_name) {
                    case 'AIRLINE_CODE':
                        columns.push({ label: 'airline-code', field_name: preference.field_name, checked: preference.active, order_by: 'airline_code', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'airline_code' : order_by;
                        break;
                    case 'COMMERCIAL_NAME':
                        columns.push({ label: 'commercial-name', field_name: preference.field_name, checked: preference.active, order_by: 'commercial_name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'commercial_name' : order_by;
                        break;
                    case 'ALLIANCE':
                        columns.push({ label: 'alliance', field_name: preference.field_name, checked: preference.active, order_by: 'alliance', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'alliance' : order_by;
                        break;
                    default:
                        break;
                }
                preferences.push(preference);
                field_name.push(preference.field_name);
                order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : order;
            }
        }
    });
    if (columns.length !== state_columns.length) {
        state_columns.map(column => {
            let added = false;
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].label === column.label) {
                    added = true;
                    break;
                }
            }
            if (!added) {
                columns.push({ ...column });
            }
        });
    }
    return { order_by, order, columns, preferences };
};
